// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.8.3
//   protoc               v7.35.1
// source: mypascom.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import {
  CloseTicketRequest,
  GetTicketAttachmentDownloadUrlRequest,
  GetTicketDetailRequest,
  GetTicketListRequest,
} from "./hubspotr";

export const protobufPackage = "pc.proto.mypascom";

/** Attachment prepared for upload - uses asset_key which BE resolves to download_url */
export interface PreparedTicketAttachment {
  assetKey: string;
  filename: string;
}

/** mypascom BE must ensure, whether the customer has access to the appliance or not */
export interface CreateTicketRequest {
  applianceId: string;
  title: string;
  body: string;
  attachments: PreparedTicketAttachment[];
}

/** Add a text message to a ticket conversation */
export interface AddMessageConversationEntryRequest {
  threadId: string;
  senderEmail: string;
  body: string;
  attachments: PreparedTicketAttachment[];
}

export interface AddMessageConversationEntryResponse {
  outcome: AddMessageConversationEntryResponse_Outcome;
}

export enum AddMessageConversationEntryResponse_Outcome {
  OUTCOME_UNKNOWN = 0,
  OUTCOME_SUCCESS = 1,
  OUTCOME_ERROR = 2,
  UNRECOGNIZED = -1,
}

export function addMessageConversationEntryResponse_OutcomeFromJSON(
  object: any,
): AddMessageConversationEntryResponse_Outcome {
  switch (object) {
    case 0:
    case "OUTCOME_UNKNOWN":
      return AddMessageConversationEntryResponse_Outcome.OUTCOME_UNKNOWN;
    case 1:
    case "OUTCOME_SUCCESS":
      return AddMessageConversationEntryResponse_Outcome.OUTCOME_SUCCESS;
    case 2:
    case "OUTCOME_ERROR":
      return AddMessageConversationEntryResponse_Outcome.OUTCOME_ERROR;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AddMessageConversationEntryResponse_Outcome.UNRECOGNIZED;
  }
}

export function addMessageConversationEntryResponse_OutcomeToJSON(
  object: AddMessageConversationEntryResponse_Outcome,
): string {
  switch (object) {
    case AddMessageConversationEntryResponse_Outcome.OUTCOME_UNKNOWN:
      return "OUTCOME_UNKNOWN";
    case AddMessageConversationEntryResponse_Outcome.OUTCOME_SUCCESS:
      return "OUTCOME_SUCCESS";
    case AddMessageConversationEntryResponse_Outcome.OUTCOME_ERROR:
      return "OUTCOME_ERROR";
    case AddMessageConversationEntryResponse_Outcome.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface TicketRequest {
  request?:
    | { $case: "createTicketRequest"; createTicketRequest: CreateTicketRequest }
    | { $case: "getTicketDetailRequest"; getTicketDetailRequest: GetTicketDetailRequest }
    | { $case: "getTicketListRequest"; getTicketListRequest: GetTicketListRequest }
    | {
      $case: "getTicketAttachmentDownloadUrlRequest";
      getTicketAttachmentDownloadUrlRequest: GetTicketAttachmentDownloadUrlRequest;
    }
    | { $case: "closeTicketRequest"; closeTicketRequest: CloseTicketRequest }
    | {
      $case: "addMessageConversationEntryRequest";
      addMessageConversationEntryRequest: AddMessageConversationEntryRequest;
    }
    | undefined;
}

function createBasePreparedTicketAttachment(): PreparedTicketAttachment {
  return { assetKey: "", filename: "" };
}

export const PreparedTicketAttachment: MessageFns<PreparedTicketAttachment> = {
  encode(message: PreparedTicketAttachment, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.assetKey !== "") {
      writer.uint32(10).string(message.assetKey);
    }
    if (message.filename !== "") {
      writer.uint32(18).string(message.filename);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PreparedTicketAttachment {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePreparedTicketAttachment();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.assetKey = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.filename = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PreparedTicketAttachment {
    return {
      assetKey: isSet(object.assetKey) ? globalThis.String(object.assetKey) : "",
      filename: isSet(object.filename) ? globalThis.String(object.filename) : "",
    };
  },

  toJSON(message: PreparedTicketAttachment): unknown {
    const obj: any = {};
    if (message.assetKey !== "") {
      obj.assetKey = message.assetKey;
    }
    if (message.filename !== "") {
      obj.filename = message.filename;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PreparedTicketAttachment>, I>>(base?: I): PreparedTicketAttachment {
    return PreparedTicketAttachment.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PreparedTicketAttachment>, I>>(object: I): PreparedTicketAttachment {
    const message = createBasePreparedTicketAttachment();
    message.assetKey = object.assetKey ?? "";
    message.filename = object.filename ?? "";
    return message;
  },
};

function createBaseCreateTicketRequest(): CreateTicketRequest {
  return { applianceId: "", title: "", body: "", attachments: [] };
}

export const CreateTicketRequest: MessageFns<CreateTicketRequest> = {
  encode(message: CreateTicketRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.applianceId !== "") {
      writer.uint32(10).string(message.applianceId);
    }
    if (message.title !== "") {
      writer.uint32(18).string(message.title);
    }
    if (message.body !== "") {
      writer.uint32(26).string(message.body);
    }
    for (const v of message.attachments) {
      PreparedTicketAttachment.encode(v!, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateTicketRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateTicketRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.applianceId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.title = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.body = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.attachments.push(PreparedTicketAttachment.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateTicketRequest {
    return {
      applianceId: isSet(object.applianceId) ? globalThis.String(object.applianceId) : "",
      title: isSet(object.title) ? globalThis.String(object.title) : "",
      body: isSet(object.body) ? globalThis.String(object.body) : "",
      attachments: globalThis.Array.isArray(object?.attachments)
        ? object.attachments.map((e: any) => PreparedTicketAttachment.fromJSON(e))
        : [],
    };
  },

  toJSON(message: CreateTicketRequest): unknown {
    const obj: any = {};
    if (message.applianceId !== "") {
      obj.applianceId = message.applianceId;
    }
    if (message.title !== "") {
      obj.title = message.title;
    }
    if (message.body !== "") {
      obj.body = message.body;
    }
    if (message.attachments?.length) {
      obj.attachments = message.attachments.map((e) => PreparedTicketAttachment.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateTicketRequest>, I>>(base?: I): CreateTicketRequest {
    return CreateTicketRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateTicketRequest>, I>>(object: I): CreateTicketRequest {
    const message = createBaseCreateTicketRequest();
    message.applianceId = object.applianceId ?? "";
    message.title = object.title ?? "";
    message.body = object.body ?? "";
    message.attachments = object.attachments?.map((e) => PreparedTicketAttachment.fromPartial(e)) || [];
    return message;
  },
};

function createBaseAddMessageConversationEntryRequest(): AddMessageConversationEntryRequest {
  return { threadId: "", senderEmail: "", body: "", attachments: [] };
}

export const AddMessageConversationEntryRequest: MessageFns<AddMessageConversationEntryRequest> = {
  encode(message: AddMessageConversationEntryRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.threadId !== "") {
      writer.uint32(10).string(message.threadId);
    }
    if (message.senderEmail !== "") {
      writer.uint32(18).string(message.senderEmail);
    }
    if (message.body !== "") {
      writer.uint32(26).string(message.body);
    }
    for (const v of message.attachments) {
      PreparedTicketAttachment.encode(v!, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AddMessageConversationEntryRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAddMessageConversationEntryRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.threadId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.senderEmail = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.body = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.attachments.push(PreparedTicketAttachment.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AddMessageConversationEntryRequest {
    return {
      threadId: isSet(object.threadId) ? globalThis.String(object.threadId) : "",
      senderEmail: isSet(object.senderEmail) ? globalThis.String(object.senderEmail) : "",
      body: isSet(object.body) ? globalThis.String(object.body) : "",
      attachments: globalThis.Array.isArray(object?.attachments)
        ? object.attachments.map((e: any) => PreparedTicketAttachment.fromJSON(e))
        : [],
    };
  },

  toJSON(message: AddMessageConversationEntryRequest): unknown {
    const obj: any = {};
    if (message.threadId !== "") {
      obj.threadId = message.threadId;
    }
    if (message.senderEmail !== "") {
      obj.senderEmail = message.senderEmail;
    }
    if (message.body !== "") {
      obj.body = message.body;
    }
    if (message.attachments?.length) {
      obj.attachments = message.attachments.map((e) => PreparedTicketAttachment.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AddMessageConversationEntryRequest>, I>>(
    base?: I,
  ): AddMessageConversationEntryRequest {
    return AddMessageConversationEntryRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AddMessageConversationEntryRequest>, I>>(
    object: I,
  ): AddMessageConversationEntryRequest {
    const message = createBaseAddMessageConversationEntryRequest();
    message.threadId = object.threadId ?? "";
    message.senderEmail = object.senderEmail ?? "";
    message.body = object.body ?? "";
    message.attachments = object.attachments?.map((e) => PreparedTicketAttachment.fromPartial(e)) || [];
    return message;
  },
};

function createBaseAddMessageConversationEntryResponse(): AddMessageConversationEntryResponse {
  return { outcome: 0 };
}

export const AddMessageConversationEntryResponse: MessageFns<AddMessageConversationEntryResponse> = {
  encode(message: AddMessageConversationEntryResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.outcome !== 0) {
      writer.uint32(8).int32(message.outcome);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AddMessageConversationEntryResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAddMessageConversationEntryResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.outcome = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AddMessageConversationEntryResponse {
    return { outcome: isSet(object.outcome) ? addMessageConversationEntryResponse_OutcomeFromJSON(object.outcome) : 0 };
  },

  toJSON(message: AddMessageConversationEntryResponse): unknown {
    const obj: any = {};
    if (message.outcome !== 0) {
      obj.outcome = addMessageConversationEntryResponse_OutcomeToJSON(message.outcome);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AddMessageConversationEntryResponse>, I>>(
    base?: I,
  ): AddMessageConversationEntryResponse {
    return AddMessageConversationEntryResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AddMessageConversationEntryResponse>, I>>(
    object: I,
  ): AddMessageConversationEntryResponse {
    const message = createBaseAddMessageConversationEntryResponse();
    message.outcome = object.outcome ?? 0;
    return message;
  },
};

function createBaseTicketRequest(): TicketRequest {
  return { request: undefined };
}

export const TicketRequest: MessageFns<TicketRequest> = {
  encode(message: TicketRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    switch (message.request?.$case) {
      case "createTicketRequest":
        CreateTicketRequest.encode(message.request.createTicketRequest, writer.uint32(10).fork()).join();
        break;
      case "getTicketDetailRequest":
        GetTicketDetailRequest.encode(message.request.getTicketDetailRequest, writer.uint32(18).fork()).join();
        break;
      case "getTicketListRequest":
        GetTicketListRequest.encode(message.request.getTicketListRequest, writer.uint32(26).fork()).join();
        break;
      case "getTicketAttachmentDownloadUrlRequest":
        GetTicketAttachmentDownloadUrlRequest.encode(
          message.request.getTicketAttachmentDownloadUrlRequest,
          writer.uint32(34).fork(),
        ).join();
        break;
      case "closeTicketRequest":
        CloseTicketRequest.encode(message.request.closeTicketRequest, writer.uint32(42).fork()).join();
        break;
      case "addMessageConversationEntryRequest":
        AddMessageConversationEntryRequest.encode(
          message.request.addMessageConversationEntryRequest,
          writer.uint32(50).fork(),
        ).join();
        break;
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TicketRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTicketRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.request = {
            $case: "createTicketRequest",
            createTicketRequest: CreateTicketRequest.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.request = {
            $case: "getTicketDetailRequest",
            getTicketDetailRequest: GetTicketDetailRequest.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.request = {
            $case: "getTicketListRequest",
            getTicketListRequest: GetTicketListRequest.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.request = {
            $case: "getTicketAttachmentDownloadUrlRequest",
            getTicketAttachmentDownloadUrlRequest: GetTicketAttachmentDownloadUrlRequest.decode(
              reader,
              reader.uint32(),
            ),
          };
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.request = {
            $case: "closeTicketRequest",
            closeTicketRequest: CloseTicketRequest.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.request = {
            $case: "addMessageConversationEntryRequest",
            addMessageConversationEntryRequest: AddMessageConversationEntryRequest.decode(reader, reader.uint32()),
          };
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TicketRequest {
    return {
      request: isSet(object.createTicketRequest)
        ? {
          $case: "createTicketRequest",
          createTicketRequest: CreateTicketRequest.fromJSON(object.createTicketRequest),
        }
        : isSet(object.getTicketDetailRequest)
        ? {
          $case: "getTicketDetailRequest",
          getTicketDetailRequest: GetTicketDetailRequest.fromJSON(object.getTicketDetailRequest),
        }
        : isSet(object.getTicketListRequest)
        ? {
          $case: "getTicketListRequest",
          getTicketListRequest: GetTicketListRequest.fromJSON(object.getTicketListRequest),
        }
        : isSet(object.getTicketAttachmentDownloadUrlRequest)
        ? {
          $case: "getTicketAttachmentDownloadUrlRequest",
          getTicketAttachmentDownloadUrlRequest: GetTicketAttachmentDownloadUrlRequest.fromJSON(
            object.getTicketAttachmentDownloadUrlRequest,
          ),
        }
        : isSet(object.closeTicketRequest)
        ? { $case: "closeTicketRequest", closeTicketRequest: CloseTicketRequest.fromJSON(object.closeTicketRequest) }
        : isSet(object.addMessageConversationEntryRequest)
        ? {
          $case: "addMessageConversationEntryRequest",
          addMessageConversationEntryRequest: AddMessageConversationEntryRequest.fromJSON(
            object.addMessageConversationEntryRequest,
          ),
        }
        : undefined,
    };
  },

  toJSON(message: TicketRequest): unknown {
    const obj: any = {};
    if (message.request?.$case === "createTicketRequest") {
      obj.createTicketRequest = CreateTicketRequest.toJSON(message.request.createTicketRequest);
    } else if (message.request?.$case === "getTicketDetailRequest") {
      obj.getTicketDetailRequest = GetTicketDetailRequest.toJSON(message.request.getTicketDetailRequest);
    } else if (message.request?.$case === "getTicketListRequest") {
      obj.getTicketListRequest = GetTicketListRequest.toJSON(message.request.getTicketListRequest);
    } else if (message.request?.$case === "getTicketAttachmentDownloadUrlRequest") {
      obj.getTicketAttachmentDownloadUrlRequest = GetTicketAttachmentDownloadUrlRequest.toJSON(
        message.request.getTicketAttachmentDownloadUrlRequest,
      );
    } else if (message.request?.$case === "closeTicketRequest") {
      obj.closeTicketRequest = CloseTicketRequest.toJSON(message.request.closeTicketRequest);
    } else if (message.request?.$case === "addMessageConversationEntryRequest") {
      obj.addMessageConversationEntryRequest = AddMessageConversationEntryRequest.toJSON(
        message.request.addMessageConversationEntryRequest,
      );
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TicketRequest>, I>>(base?: I): TicketRequest {
    return TicketRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TicketRequest>, I>>(object: I): TicketRequest {
    const message = createBaseTicketRequest();
    switch (object.request?.$case) {
      case "createTicketRequest": {
        if (object.request?.createTicketRequest !== undefined && object.request?.createTicketRequest !== null) {
          message.request = {
            $case: "createTicketRequest",
            createTicketRequest: CreateTicketRequest.fromPartial(object.request.createTicketRequest),
          };
        }
        break;
      }
      case "getTicketDetailRequest": {
        if (object.request?.getTicketDetailRequest !== undefined && object.request?.getTicketDetailRequest !== null) {
          message.request = {
            $case: "getTicketDetailRequest",
            getTicketDetailRequest: GetTicketDetailRequest.fromPartial(object.request.getTicketDetailRequest),
          };
        }
        break;
      }
      case "getTicketListRequest": {
        if (object.request?.getTicketListRequest !== undefined && object.request?.getTicketListRequest !== null) {
          message.request = {
            $case: "getTicketListRequest",
            getTicketListRequest: GetTicketListRequest.fromPartial(object.request.getTicketListRequest),
          };
        }
        break;
      }
      case "getTicketAttachmentDownloadUrlRequest": {
        if (
          object.request?.getTicketAttachmentDownloadUrlRequest !== undefined &&
          object.request?.getTicketAttachmentDownloadUrlRequest !== null
        ) {
          message.request = {
            $case: "getTicketAttachmentDownloadUrlRequest",
            getTicketAttachmentDownloadUrlRequest: GetTicketAttachmentDownloadUrlRequest.fromPartial(
              object.request.getTicketAttachmentDownloadUrlRequest,
            ),
          };
        }
        break;
      }
      case "closeTicketRequest": {
        if (object.request?.closeTicketRequest !== undefined && object.request?.closeTicketRequest !== null) {
          message.request = {
            $case: "closeTicketRequest",
            closeTicketRequest: CloseTicketRequest.fromPartial(object.request.closeTicketRequest),
          };
        }
        break;
      }
      case "addMessageConversationEntryRequest": {
        if (
          object.request?.addMessageConversationEntryRequest !== undefined &&
          object.request?.addMessageConversationEntryRequest !== null
        ) {
          message.request = {
            $case: "addMessageConversationEntryRequest",
            addMessageConversationEntryRequest: AddMessageConversationEntryRequest.fromPartial(
              object.request.addMessageConversationEntryRequest,
            ),
          };
        }
        break;
      }
    }
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string } ? { [K in keyof Omit<T, "$case">]?: DeepPartial<T[K]> } & { $case: T["$case"] }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
